import cn from 'classnames';
import React from 'react';
import Search from './Search';
import NewIssueFilings from './NewIssueFilingsTabs';

import tabsStyles from '@dealroadshow/uikit/core/styles/tabs.scss';
import cardStyles from '@dealroadshow/uikit/core/styles/card.scss';
import styles from './loanLevelHeader.scss';
import { useFilingContext } from '@/finsight/application/Filings/FilingsContext';

interface IProps {
  children: React.ReactNode,
}
const LoanLevelHeader = ({ children }: IProps) => {
  const { handleSearchChange } = useFilingContext();

  return (
    <>
      <div className={ cn(cardStyles.cardInnerHorizontal, styles.cardHeader) }>
        <div className={ styles.actions }>
          <Search onSearchChange={ handleSearchChange } />
        </div>
        <NewIssueFilings />
      </div>
      <div className={ cn(tabsStyles.tabsFooter, styles.tabsFooter) } />
      { children }
    </>
  );
};

export default LoanLevelHeader;
